<template>
  <v-menu v-model="menu_ativo" :close-on-content-click="false" transition="scale-transition">
    <template v-slot:activator="{}">
      <SysBtn :size="3" class="ml-3 cursor-pointer" @click="menu_ativo = !menu_ativo">
        <Legenda titulo="Ordem Níveis Expansão">
          <div class="cursor-pointer">
            <v-icon size="18">$OrderAlphabeticalAscending</v-icon>
            <span class="ml-1">Ordem Níveis Expansão</span>
          </div>

          <template #legenda>
            <ul class="list-style-type-none ml-n6">
              <li
                v-for="(item, key) in callbacks_ordem_dinamicas"
                :key="key"
                v-text="`${key + 1} - ${item.descricao}`"
              />
            </ul>
          </template>
        </Legenda>
      </SysBtn>
    </template>

    <v-card class="pb-2 w-375 border-gray-500 overflow-y-auto" elevation="10" style="max-height: 95vh">
      <v-card-title class="pl-4 pr-1 py-2">
        <div>
          <p class="ma-0 font-18 text-gray-900">Ordem dos Níveis de Expansão</p>
          <p class="ma-0 font-12 font-weight-regular mt-n3 text-gray-200">Click e arrate para mudar a ordenação</p>
        </div>

        <v-spacer />

        <v-btn icon @click="menu_ativo = !menu_ativo">
          <v-icon size="22">mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <div class="bg-gray-200 border-gray-400 mx-4 px-2 pt-2 pb-1">
        <ul class="list-style-type-none ml-n6">
          <li
            v-for="(item, key) in callbacks_ordem_dinamicas"
            :key="key"
            class="d-flex align-center h-25px bg-white border-gray-400 mb-1 px-2 cursor-pointer"
            :class="{
              'item-sendo-arrastado': item_sendo_arrastado && item_sendo_arrastado.index === item.index,
              'nivel-ocultado': !item.visivel,
            }"
            :draggable="key > 0"
            @dragstart="() => dragstart(item)"
            @dragover="() => dragover(item)"
            @dragend="item_sendo_arrastado = null"
          >
            <span
              class="font-13"
              :class="{'text-gray-1100': item.visivel, 'text-gray-50': !item.visivel}"
              v-text="`${key + 1}. ${item.descricao}`"
            />

            <v-spacer />

            <template v-if="key === 0" class="font-13">
              <span class="font-10 mr-1">FIXO</span>
              <span v-if="key === 0" class="font-13">🔒</span>
            </template>

            <span v-else @click="item.visivel = ! item.visivel">
              <v-icon v-if="item.visivel" :size="18" title="Ocultar nível">mdi-eye</v-icon>
              <v-icon v-else :size="18" color="#cecece" title="Exibir nível">mdi-eye-off</v-icon>
            </span>
          </li>
        </ul>
      </div>

      <div class="d-flex justify-end px-4 mt-3">
        <v-btn small color="#042333" dark @click="aplicarOrdemNiveis">
          Aplicar
        </v-btn>
      </div>
    </v-card>
  </v-menu>
</template>

<script setup>
import { ref } from "vue";
import store from "@/store";
import { lista_padrao_callbacks } from "@/components/Diagnostico/AnaliseEstoque/AnaliseQualitativaDoEstoque/EndPointAPI.js";
import Legenda from "@/components/produto/detalhes/Legenda.vue";

const callbacks_ordem_dinamicas = ref(lista_padrao_callbacks.map((item, index) => ({...item, visivel: true, index})));
const menu_ativo = ref(false);
const item_sendo_arrastado = ref(null);

function dragstart(item) {
  item_sendo_arrastado.value = item;
}

function dragover(item) {
  if (item_sendo_arrastado.value.index === item.index || item.index === 0) return;

  const index_of = callbacks_ordem_dinamicas.value.indexOf(item);
  callbacks_ordem_dinamicas.value = callbacks_ordem_dinamicas.value.filter(calback => calback.index !== item_sendo_arrastado.value.index);
  callbacks_ordem_dinamicas.value.splice(index_of, 0, item_sendo_arrastado.value);
}

function aplicarOrdemNiveis() {
  menu_ativo.value = false;
  const callbacks = callbacks_ordem_dinamicas.value
    .filter(item => item.visivel)
    .map(item => item.callback);
  store.dispatch("diagnosticoAnaliseQualitativaEstoque/callbacksGridPrincipal", callbacks)
}
</script>

<style scoped>
.item-sendo-arrastado {
  border: 0.13rem dashed #5983c3;
}

.nivel-ocultado {
  background: #FAFAFA;
  border: 1px solid #eceaea;
  color: #FAFAFA;
}
</style>
